/* eslint-disable react/sort-comp */
import DeletionContext from 'src/MultiDeletionFunctionality/@state/DeletionStateContext';
import DELETE_ACTIONS from 'src/MultiDeletionFunctionality/@state_manager/actions';
import Fetch from 'helpers/fetch';
import React, { useState, useContext, Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import PrepaidRequestMobile from './PrepaidRequestMobile/PrepaidRequestMobile';
import PrepaidRequestDesktop from './PrepaidRequestDesktop/PrepaidRequestDesktop';
import {
  ContentSwitch, 
  ConfirmModal,
  ConfirmDelete,
  ResendMailConfirmationModel
} from 'Components';
import pageSizes from "constants/pageSizes";
import rowRules from 'helpers/rowRules';
import { confirmJobsStatus } from 'helpers/confirmStatus';
import {
  SUBMISSIONS,
  SUPPLIES,
  TEMPLATES,
} from 'constants/apis';
import menuOptions from 'constants/menuOptions';


const searchValues = {
  'Draft': { RequestStatus: 'D' },
  'Pending': { RequestStatus: 'E' },
  'Paid': { RequestStatus: 'P' },
  'Cancelled': { RequestStatus: 'C' },
  'All Requests': {},
};

const PrepaidRequest = (props) => {
  const context = useContext(DeletionContext);
  const { deletionState, dispatch } = context;
  const [initialized, setInitialized] = useState(false);
  const [state, setState] = useState({
    tabs: Object.keys(searchValues),
    tabIndex: -1,
    searchValues,
    powerTableIndex: null,
    loading: true,
    isShowDeleteConfirmation: false,
    isShowCancelConfirmation: false,
    itemToChange:undefined,
    cancelItemComments: '',
    isShowResendConfirmationModel: false,
    submissionId: 0,
    emailList: '',
    option: '',
    editItemComments:'',
    auditTrailItem: '',
    isAuditTrailItemShowing: false,
  });

  useEffect(() => {
    dispatch({
      type: DELETE_ACTIONS.UPDATE_DELETION_STATE,
      payload: {
        data: props.data.data, 
        tableCode: props.data.code,
        idName: 'SubmissionId',
        selectedItems: [],
        itemsAllowedToDelete: [],
        isDeletionModeActive: false,
        isDeleteConfirmationActive: false,
      },
    });
    dispatch({ type: DELETE_ACTIONS.GENERATE_ALLOWED_ITEMS_LIST });
    props.setAppState({isNavCollapsed: true,})
  }, [JSON.stringify(deletionState.data), props.data.isLoading])

  const setAppState = (prepaidState) => {
    props.setAppState((prevState) => ({
      prepaidrequest: {
        ...prevState.prepaidrequest,
        ...prepaidState,
      }
    }));
  }

 
  const handleTabClick = (tabIndex = 0) => {
    setAppState({
      tabIndex,
      pageNumber: 1,
      shouldLoad: state.tabIndex !== tabIndex,
      searchParams: {
        RequestStatus: searchValues[state.tabs[tabIndex]].RequestStatus,
      },
    });
    setState({ ...state, tabIndex })
  }

  if (!initialized) {   
    setInitialized(true);
    props.setHeadTitle(i18n.t('head:Prepaid Request Queue'));
    handleTabClick();    
  }

  const setPageState = (newState, callback = null) => {
    setState({...state, ...newState});
  }

  const handlePageNumberChange = (pageNumber) => {
    setAppState({
      shouldLoad: true,
      pageNumber
    });
  }

  const handlePageSizeChange = (e) => {
    setAppState({
      shouldLoad: true,
      pageSize: Number(e.target.value),
      pageNumber: 1
    });
  }

  const refreshTable = () => {
    setAppState({ shouldLoad: true, });
  }

  const handleResendModal=()=> {
    setState({
      ...state,
      processing: false,
      isShowResendConfirmationModel: false,
      submissionId: 0,
      emailList: '',
      option:'',
    });
  }

  const onResendEmailProcced = (emailList) => {
    let URL;
    if (state.option === 'request') {
      URL = `${SUBMISSIONS}/${state.submissionId}/PaymentLink?region=${localStorage.getItem('Region')}&resendEmailList=${emailList}`;
    }
    else if (state.option === 'receipt'){
      URL = `${SUBMISSIONS}/${state.submissionId}/PaymentReceipt?resendEmailList=${emailList}`;
    }
    
    handleResendModal();
    Fetch.Get(URL)
      .then((response) => {
        console.log('email has been sent');
      })
      .catch(({ err }) => {
        log.error(err);
      });
  }
  const onCancelProcced = (item) => {
    setState({ ...state, isShowCancelConfirmation :false})
    confirmJobsStatus(item)
      .then(() => {
        props.setAppState({ isChangingObject: true });
        Fetch.Put(`${SUBMISSIONS}/${item.SubmissionId}/Cancel`, 
          state.cancelItemComments,
        ).then(() => {
          setState({ ...state, cancelItemComments: '', itemToChange: undefined,isShowCancelConfirmation:false });
          props.setAppState((prevState) => ({
            isChangingObject: false,
            prepaidrequest: {
              ...prevState.prepaidrequest,
              shouldLoad: true,
            },
          }));
        });
      })
      .catch(() => refreshTable());
  }

  const deleteSelectedItems = (selectedItemsForDeletion)=> {
    const { dispatch } = context;

    setState({
      ...state,
      isShowDeleteConfirmation: false,
      itemToChange: undefined,
      powerTableIndex: null,
    });

    props.setAppState((prevState) => ({
      prepaidrequest: {
        ...prevState.prepaidrequest,
        isDeleting: true,
      },
      isGlobalLoaderShowing: true,
    }));

    Fetch.Delete(SUBMISSIONS, { IdList: selectedItemsForDeletion })
      .then(() => {
        props.setAppState((prevState) => ({
          prepaidrequest: {
            ...prevState.prepaidrequest,
            shouldLoad: true,
          },
        }));
        dispatch({ type: DELETE_ACTIONS.SUCCESSFUL_DELETION });
      })
      .catch(({ response }) => props.onAPIError(response, true))
      .finally(() => {
        props.setAppState((prevState) => ({
          prepaidrequest: {
            ...prevState.prepaidrequest,
            isDeleting: false,
          },
          isGlobalLoaderShowing: false,
        }));
      });
  }

  const deleteSubmission = (item) => {
    setState({
      ...state,
      isShowDeleteConfirmation: false,
      itemToChange: undefined,
      powerTableIndex: null,
    });
   props.setAppState((prevState) => ({
      prepaidrequest: {
        ...prevState.prepaidrequest,
        isDeleting: true,
      },
      isGlobalLoaderShowing: true,
    }));

    Fetch.Delete(SUBMISSIONS, { IdList: [item.SubmissionId] })
      .then(() => {
        props.setAppState((prevState) => ({
          prepaidrequest: {
            ...prevState.prepaidrequest,
            shouldLoad: true,
          },
        }));
      })
      .catch(({ response }) => props.onAPIError(response, true))
      .finally(() => {
        props.setAppState((prevState) => ({
          prepaidrequest: {
            ...prevState.prepaidrequest,
            isDeleting: false,
          },
          isGlobalLoaderShowing: false,
        }));
      });
  }
  const onAuditProceed = (item) => {
    const Id = item.SubmissionId;
    setState({ ...state, isAuditTrailItemShowing: false })
    props.setAppState({ isChangingObject: true,formIndex:0 });
    Fetch.Put(`${SUBMISSIONS}/${Id}/Edit`)
      .then(() => props.history.push(`/submissions/${Id}/edit`))
      .then(() => {
        setState({ ...state, auditTrailItem: undefined, isAuditTrailItemShowing:false });
        props.setAppState((prevState) => ({
          isChangingObject: false,
          ChangeLogComments: prevState.ChangeLogComments === undefined ? '' : prevState.ChangeLogComments,
        }));
      });
  }
  const handleOnOptionClick = (code, i) => {
    const { dispatch } = context;
    const item = props.data.data[i];
    const copyBody = { CopySubmissionId: item.SubmissionId };

    setState({ ...state, powerTableIndex: null});

    if (code === 'view') {
      confirmJobsStatus(item)
        .then(() => {
          if ( item.RequestStatus !== 'D') {
            props.setAppState({ formIndex: 5}); 
          }
          else if (item.Status === 'S') {
            props.setAppState({ formIndex: 4 });
          } else {
            props.setAppState({ formIndex: 2 });
          }

          props.history.push(
            `/submissions/${encodeURIComponent(item.SubmissionId)}/edit`,
          );
        })
        .catch(() => refreshTable());
    } else if (code === 'edit') {
      confirmJobsStatus(item)
        .then(() => {
          if (
            item.Status === 'S' ||
            item.Status === 'E' ||
            item.Status === 'C'
          ) {
            setState({
              ...state,
              auditTrailItem: item,
              isAuditTrailItemShowing: true,
            });
          } else {
            props.setAppState({ formIndex: 0 });
            props.history.push(
              `/submissions/${encodeURIComponent(item.SubmissionId)}/edit`,
            );
          }
        })
        .catch(() => refreshTable());
    } else if (code === 'newTemplate') {
      props.setAppState({ isCreatingObject: true });

      Fetch.Post(TEMPLATES, copyBody)
        .then((data) => data.json())
        .then((json) =>
          props.history.push(`/templates/${json.DataItem.Id}/edit`),
        )
        .then(() =>
          props.setAppState({ isCreatingObject: false, formIndex: 0 }),
        )
        .catch(({ response }) => props.onAPIError(response, true))
        .finally(() => props.setAppState({ isCreatingObject: false }));
    } else if (code === 'newSubmission') {
      props.setAppState({ isCreatingObject: true });

      Fetch.Post(`${SUBMISSIONS}/submission/${item.SubmissionId}`)
        .then((data) => data.json())
        .then((json) =>
          props.history.push(`/submissions/${json.DataItem.Id}/edit`),
        )
        .then(() =>
          props.setAppState({ isCreatingObject: false, formIndex: 0 }),
        )
        .catch(({ response }) => props.onAPIError(response, true))
        .finally(() => props.setAppState({ isCreatingObject: false }));
    } else if (code === 'newOrder') {
      props.setAppState({ isCreatingObject: true });
      if (props.isPrepaid) {
        Fetch.Post(`${SUBMISSIONS}/submission/${item.SubmissionId}?requireOrder=true`)
          .then((data) => data.json())
          .then((json) =>
            props.history.push(`/submissions/${json.DataItem.Id}/edit`),)
          .then(() =>
            props.setAppState({ isCreatingObject: false, formIndex: 0, isPrepaidOrder:true}),
          )
          .catch(({ response }) => props.onAPIError(response, true))
          .finally(() => props.setAppState({ isCreatingObject: false }));
      }
      else {
        Fetch.Post(SUPPLIES, copyBody)
          .then((data) => data.json())
          .then((json) =>
            props.history.push(
              `/supplies/${json.DataItem.OrderNumber}/edit`,
            ),
          )
          .then(() =>
            props.setAppState({ isCreatingObject: false, formIndex: 0 }),
          )
          .catch(({ response }) => props.onAPIError(response, true))
          .finally(() => props.setAppState({ isCreatingObject: false }));
      }
    } else if (code === 'multiDelete') {
      dispatch({
        type: DELETE_ACTIONS.ACTIVATE_DELETION_MODE,
        payload: { id: item.SubmissionId },
      });
    } else if (code === 'delete') {
      confirmJobsStatus(item)
        .then(() => {
          if (item.Status === 'D' || item.Status === 'C') {
            setState({
              ...state,
              itemToChange: item,
              isShowDeleteConfirmation: true,
            });
          }
        })
        .catch(() => refreshTable());
    } else if (code === 'cancel') {
      setState({
        ...state,
        isShowCancelConfirmation: true,
        itemToChange:item,
      });        
    } else if (code === 'share') {
      props.setAppState({
        shareId: item.SubmissionId,
        shareCode: 'Submission',
      });
    } else if (code === 'trackingForm') {
      DownloadFromUrl(
        `${SUBMISSIONS}/${item.SubmissionId}/GetPhysicalTrackingForm`,
      ).catch(({ response }) => props.onAPIError(response, true));
    } else if (code === 'submissionSummary') {
      DownloadFromUrl(
        `${SUBMISSIONS}/${item.SubmissionId}/GetGenericPDF?SummaryFormat=true`,
      ).catch(({ response }) => props.onAPIError(response, true));
    } else if (code === 'submissionDetails') {
      DownloadFromUrl(
        `${SUBMISSIONS}/${item.SubmissionId}/GetGenericPDF?SummaryFormat=false`,
      ).catch(({ response }) => props.onAPIError(response, true));
    } else if (code === 'request') {
      setState({ 
        ...state,
        isShowResendConfirmationModel: true, 
        submissionId: item.SubmissionId,
        emailList: item.ContactEmail,
        option: code
      });
        
    } else if (code === 'receipt') {
      setState({
        ...state,
        isShowResendConfirmationModel: true,
        submissionId: item.SubmissionId,
        emailList: item.ContactEmail,
        option: code
      });

    } else if (code === 'paynow') {      
      setState({ ...state, processing: true });
       confirmJobsStatus(item)
         .then(() => {
        Fetch.Get(`${SUBMISSIONS}/${item.SubmissionId}/PayNow?region=${localStorage.getItem('Region')}`)
        .then((response) => response.json())
        .then((data) => {
          if (data.Message.includes('&PrefixInvoiceNumber')) {
            window.open(`${window.location.origin}/PayInvoice?${data.Message}`, "_blank", "noreferrer");
          }
        })
      })
      .catch(() => refreshTable());
    }
  }

  const sharedProps = {
    setPageState: setPageState,
    handleTabClick: handleTabClick,
    handleSorting: setAppState,
    deleteSelectedItems: deleteSelectedItems,
    onPageChange: handlePageNumberChange,
    onPageSizeChange: handlePageSizeChange,
    pageSizes,
    rowRules: rowRules.job,
    onOptionClick: handleOnOptionClick,
    menuOptions,
  };

  return (
    <Fragment>
      <ContentSwitch
        index={props.deviceIndex}
        {...state}
        {...props}
        {...sharedProps}
      >
        <PrepaidRequestMobile /> 
        <PrepaidRequestDesktop />
      </ContentSwitch>
      {state.isShowDeleteConfirmation && (
        //! Deletion Confirmation for PrepaidJobs:
        <ConfirmDelete
          title={`${i18n.t('common:Delete the')} ${i18n.t(
            'common:Submission',
          )}`}
          onCancelDelete={() =>
            setState({
              ...state,
              itemToChange: undefined,
              isShowDeleteConfirmation: false,
            })
          }
          onProceedDelete={() => deleteSubmission(state.itemToChange)}
        />
      )}
      {/* Cancel ChangeLogComments */}
      {state.isShowCancelConfirmation  && (
        <ConfirmModal
          onChange={(e) =>
            setState({ ...state, cancelItemComments: e.target.value })
          }
          value={state.cancelItemComments}
          description={i18n.t('confirmModal:cancel')}
          cancelReasonText={i18n.t('confirmModal:reason')}
          onCancelClick={()=>setState({
            ...state,
             isShowCancelConfirmation: false,
            itemToChange: undefined,
            cancelItemComments:''
            })
          }
          onProceedClick={() => onCancelProcced(state.itemToChange)
          }
        />
      )}
      {state.isShowResendConfirmationModel && (
        <ResendMailConfirmationModel
          onChange={(e) =>
            setState({ ...state, emailList: Object.values(e).join(';') })
          }
          title={state.option}
          emailList={state.emailList}
          onProcced={onResendEmailProcced}
          onCancel={handleResendModal}
        />
      )}
      {state.isAuditTrailItemShowing && (
        <ConfirmModal
          onChange={(e) => setState({ ...state, editItemComments: e.target.value })}
          value={state.editItemComments}
          description={i18n.t('confirmModal:edit')}
          cancelReasonText={i18n.t('confirmModal:reason')}
          onCancelClick={() => setState({
            ...state,
            isAuditTrailItemShowing: false,
            auditTrailItem: undefined,
            editItemComments: ''
          }) }
          onProceedClick={() => onAuditProceed(state.auditTrailItem)}
        />
      )}
    </Fragment>
  );
}

PrepaidRequest.propTypes = {
  setHeadTitle: PropTypes.func,
  setAppState: PropTypes.func,
  data: PropTypes.shape({
    isLoading: PropTypes.bool,
    isInitialized: PropTypes.bool,
    code: PropTypes.string,
    abortController: PropTypes.shape({
      abort: PropTypes.func,
    }),
    data: PropTypes.arrayOf(PropTypes.shape({})),
    tabIndex: PropTypes.number,
   
  }),
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
  filterItemValue: PropTypes.string, 
  onAPIError: PropTypes.func,
  userName: PropTypes.string,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  isSupplyWarningON: PropTypes.bool,
  isPrepaidWarningON: PropTypes.bool,
  isSubmissionWarningON: PropTypes.bool,
  isPrepaid: PropTypes.bool,
};


export default PrepaidRequest;



// WEBPACK FOOTER //
// ./src/containers/PrepaidRequest/PrepaidRequest.jsx